<template>
  <div class="data_title">
    <span class="maker"></span>
    {{title}}
  </div>
</template>

<script>
export default {
  props: ["title"]
};
</script>

<style scoped>
.data_title {
  /* background: #f7f8fa; */
  font-size: 16px;
  font-weight: 600;
  height: 35px;
  padding-left: 10px;
  line-height: 50px;
  height: 50px;
  /* border-bottom: 1px solid #0078ff; */
  margin: 20px 0px 20px 0px;
  background: #f5f9fd;
  border-top: 3px solid #32a8ff;
}
.maker {
  display: inline-block;
  width: 5px;
  height: 5px;
  border: 1px solid #0078ff;
  border-radius: 100px;
  background-color: #0078ff;
  /* opacity: 0.5; */
  vertical-align: top;
  margin-top: 23px;
  margin-right: 5px;
}
</style>